const meta = (name) => document.querySelector(`meta[name="${name}"]`)?.content;

const envConfig = {
    APP_URL: meta('app-url'),
    API_URL: meta('api-url'),
    API_LOGOUT_URL: `${meta('api-url')}/logout`,
    API_DEVICE_LOGOUT_URL: `${meta('app-url')}/sign_out`,
    SENTRY_DSN: meta('sentry-dsn'),
    CABLE_URL: meta('cable-url') || '/cable',
};

export default envConfig;